import React from "react";

import SiteUrlCard from "./siteUrlCard";
import SiteVerificationCard from "./siteVerificationCard";
import FavIconCard from "./favIconCard";
import SocialImageCard from "./socialImageCard";
import TrackingPixelsCard from "./trackingPixelsCard";
import CustomScriptCard from "./customScriptCard";
import PasswordProtectCard from "./passwordProtectCard";
import NotificationsCard from "./notificationsCard";
import AssetViewerCard from "./assetViewerCard";
import AppearanceCard from "./appearanceCard";
import GatingTriggersCard from "./gatingTriggersCard";
import { useDraft } from "./useDraft";
import { isInteractiveContent, isSlideStoryboard } from "../../utils/validation";
import { useWebsiteSettings } from "../../hooks/useWebsiteSettings";
import HeroCard from "../heroCard";

import styles from "./siteSettings.module.scss";

export type WebsiteSettingsActions = ReturnType<typeof useWebsiteSettings>;

interface SiteSettingsProps {
  actions: WebsiteSettingsActions;
  storyboardId: string;
}

const SiteSettings: React.FC<SiteSettingsProps> = ({ actions, storyboardId }) => {
  const { draft } = useDraft();
  const showAppearance = isInteractiveContent(draft?.type);
  const showAssetViewer = !isSlideStoryboard(draft?.type);

  return (
    <div className={styles.grid}>
      <div className={styles.fullWidth}>
        <HeroCard />
      </div>
      <div className={styles.column}>
        <SiteUrlCard actions={actions} />
        <FavIconCard />
        <SocialImageCard />
        <NotificationsCard />
      </div>
      <div className={styles.column}>
        <SiteVerificationCard />
        <TrackingPixelsCard />
        <PasswordProtectCard />
        <CustomScriptCard />
        {showAssetViewer && <AssetViewerCard />}
      </div>
      {showAppearance && 
        <div className={styles.fullWidth}>
          <AppearanceCard />
        </div>
      }
      <div className={styles.fullWidth}>
        <GatingTriggersCard actions={actions} storyboardId={storyboardId} />
      </div>
    </div>
  );
};

export default SiteSettings;
